<template>
  <transition name="fade">
    <span v-if="message" class="login-notice-box">
      {{ message }}
    </span>
  </transition>
</template>
<script>
export default {
  name: 'Notice',
  props: ['timeout'],
  data() {
    return {
      message: null,
      timer: null
    }
  },
  methods: {
    show(message, fn) {
      this.message = message
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.message = null
        fn && fn()
      }, this.timeout || 3000)
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';
.login-notice-box {
  max-width: 300px;
  min-width: 200px;
  position: absolute;
  padding: 10px 20px;
  background: white;
  color: @black;
  border-radius: 4px;
  box-shadow: @box-shadow-1 fade(#000000, 20);
  z-index: 10;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
